/**
 * Platform dashboard — query hook.
 */

import { useQuery } from "@tanstack/react-query";
import { apiFetch, type ApiError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import {
  platformOverviewSchema,
  type PlatformOverview,
} from "./schemas";

export async function fetchPlatformOverview(): Promise<PlatformOverview> {
  const raw = await apiFetch<unknown>("/api/v1/platform/overview");
  return platformOverviewSchema.parse(raw);
}

export function usePlatformOverviewQuery() {
  return useQuery<PlatformOverview, ApiError>({
    queryKey: queryKeys.platformOverview,
    queryFn: fetchPlatformOverview,
    // Refreshes server-side every minute; polling is fine.
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
}
